import React from "react";

const HeroSection = ({ title, tagLine, tagLineTwo, children }) => {
  return (
    <div>
      <div className="pt-12 md:pt-20">
        <div
          className="w-full"
          style={{
            position: "relative",
            background: 'url("/images/showcase-image.jpg")',
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            minHeight: "550px",
          }}
        >
          <div
            className="flex flex-col justify-center items-center px-8"
            style={{
              background: "rgba(39, 39, 39, 0.5)",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          >
            <h1
              className="text-white text-3xl md:text-4xl lg:text-6xl text-center mt-8 mb-8 sm:mt-0 sm:mb-12 font-normal"
              style={{ fontFamily: "agrandir" }}
            >
              {title}
            </h1>

            <h2
              className="text-white text-xl lg:text-2xl text-center mb-8 sm:mb-12 font-normal"
              style={{ fontFamily: "agrandir" }}
            >
              {tagLine}
            </h2>

            {tagLineTwo && (
              <h2
                className="text-white text-xl lg:text-2xl text-center mb-8 sm:mb-12 font-normal"
                style={{ fontFamily: "agrandir" }}
              >
                {tagLineTwo}
              </h2>
            )}

            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
